import api from "../axios/axios-config";

export const getReceivingGoods = async () => {
  try {
    let response = await api.get("recevingGoods/listOfRecevingGoods");
    return response?.data?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const addReceivingGoods = async (data) => {
  try {
    let response = await api.post("recevingGoods/createRecevingGoods", {
      ...data,
    });
    return response?.data?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const updateReceivingGoods = async (dataId, data) => {
  try {
    let response = await api.post("recevingGoods/updateRecevingGoods", {
      dataId,
      ...data,
    });
    return response?.data?.data;
  } catch (error) {
    console.log("ERROR", { error });
    return error?.response?.data;
  }
};
